import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-range-diagram',
    imports: [CommonModule],
    templateUrl: './range-diagram.component.html',
    styleUrls: ['./range-diagram.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RangeDiagramComponent{
  @Input()
  isCurrent?: boolean;
  @Input()
  wasChange?: boolean;
  @Input()
  value: string = "כן";
  @Input()
  percentage: number = 30;

  @Input()
  inFilter?: boolean;

  // #storeData= inject(DataSummaryStore);
  showComparison$ = toSignal(inject(DataSummaryStore).showComparison$);
  // filterRecipients$ = toSignal(this.#storeData.recipientsToFilterId$);
  // ngOnInit(): void {
  //   i
  // }
}
